// extracted by mini-css-extract-plugin
export default {"header":"Header_header__HXQOm","header__top":"Header_header__top__Ax9Ps","header__main":"Header_header__main__yNjfI","header__main_core":"Header_header__main_core__tFDFO"};